var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRightHand = function SvgRightHand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    d: "m13.138 10.632-9.232 9.841a1.68 1.68 0 0 1-2.413.034 1.683 1.683 0 0 1 .034-2.414l9.73-9.125 1.146.166z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    d: "m20.745 8.496-4.406.64-1.97 3.991-1.23-2.495-.74-1.497-1.145-.166-3.26-.473 3.187-3.108L10.429 1l3.94 2.072L18.309 1l-.752 4.388z"
  })));
};
export default SvgRightHand;